export enum UserType {
  Patient = 'Patient',
  Member = 'Member',
  ConnectedParty = 'ConnectedParty',
  Unknown = 'Unknown',
  Other = 'Other',
  Organization = 'Organization',
}
